// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import {
  ChannelBox,
  ChannelBoxTypes,
  GeoMap
} from "src/controllers/alerts/components";

import { ContactInfo, IContactInfoProps } from "./contact-info";
import { Expiration, IExpiration } from "./expiration";
import { IPawsDetailsProps, PawsDetails } from "./ipaws-details";
import { ISeverity, Severity } from "./severity";

import { MPDButton } from "src/mpd-library";

import "./styles.css";

export interface IMainProps
  extends HTMLDivProps,
    IContactInfoProps,
    ISeverity,
    IExpiration,
    IPawsDetailsProps {
  incidentLocation: any;
  onClearMap?(event: any): void;
  onBoxClick?(event: any): void;
}

export const Main: React.SFC<IMainProps> = props => {
  const {
    callerId, 
    callerName,
    className,
    onRadioChanged,
    onBoxClick,
    incidentLocation,
    tabs,
    expiration,
    onTabChanged,
    onIPawsSelectChanged,
    onExpirationSelectChanged,
    severity,
    emailFrom,
    onInputChanged,
    onToggleMoreInfo,
    iPawsDetails,
    emailReply,
    onClearMap,
    senderName,
  } = props;
  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_ALERT_DETAILS,
    className
  );
  return (
    <div className={classes}>
      <Severity severity={severity} tabs={tabs} onTabChanged={onTabChanged} />
      <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          ADD INCIDENT LOCATION <span>(OPTONAL)</span>
        </Text>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_MAP_CONTAINER}>
          {incidentLocation.status ? (
            <div className="wrapper">
              <div
                className="incident-location-map-container"
                data-id="incident-location"
                onDoubleClick={onBoxClick}
              >
                <GeoMap
                  style={{
                    height: `100%`,
                    borderRadius: "20px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
                  }}
                  boxClass="incident-map-info-box"
                  hideControls={true}
                  center={incidentLocation.center}
                  currentMarker={incidentLocation.marker}
                />
              </div>
              <MPDButton name="compose-alert-exit" onClick={onClearMap} />
            </div>
          ) : (
            <ChannelBox
              id={"incident-location"}
              onClick={onBoxClick}
              title="Add Incident Location"
              type={ChannelBoxTypes.maps}
              description="Send to a subset of users inside a geo-fenced location"
              name="compose-alert--add-location-inactive"
            />
          )}
        </div>
      </div>
      <Expiration
        onExpirationSelectChanged={onExpirationSelectChanged}
        expiration={expiration}
        onRadioChanged={onRadioChanged}
      />
      <PawsDetails
        iPawsDetails={iPawsDetails}
        onToggleMoreInfo={onToggleMoreInfo}
        onIPawsSelectChanged={onIPawsSelectChanged}
      />
      <ContactInfo
        callerId={callerId}
        callerName={callerName}
        emailReply={emailReply}
        emailFrom={emailFrom}
        senderName={senderName}
        onRadioChanged={onRadioChanged}
        onInputChanged={onInputChanged}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/main.tsx